import axios from "axios";
import { APIURL } from "../../../APIHandler/APIURL"
import { Headers } from "../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../utlis/utlis";
import { Staff_Vouchers_failure, Staff_Vouchers_request, Staff_Vouchers_success } from "../../Reducer/StaffVoucher/StaffVoucherSlice";

export const StaffVoucherAPI = (payload) => async (dispatch, getState) => {
    dispatch(Staff_Vouchers_request())
    const eventItemId=localStorage.getItem("eventItemId")
    const auth_token = localStorage.getItem("auth_token")
  
    try {
        const { data } = await axios.get(`${APIURL.Staffprogram}/${eventItemId}`, {
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
               "event-slug":Headers?.["event-slug"],
                "Content-type": "application/json",
                Authorization: `Bearer ${auth_token}`
            },
        })
        dispatch(Staff_Vouchers_success(data))

    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Staff_Vouchers_failure(error?.response?.data))

    }
}